import { Component, OnInit, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import DOMPurify from 'dompurify';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-html-dialog',
  templateUrl: './html-dialog.component.html',
})
export class HtmlDialogComponent implements OnInit {
  public readonly ref = inject(DynamicDialogRef);
  public readonly dynamicDialogConfig = inject(DynamicDialogConfig);
  private readonly sanitizer = inject(DomSanitizer);

  public htmlContent: SafeHtml = '';

  public ngOnInit() {
    const updatedHtml = this.dynamicDialogConfig.data.htmlContent.replace(
      /data-highlight-colour\s*=\s*"([^"]+)"/g,
      'style="background-color: $1"',
    );

    // Angular's own sanitizer strips inline styles, which the wiki markup relies on. DOMPurify keeps
    // styles but removes scripts/event handlers, so the result is safe to mark as trusted.
    const sanitizedHtml = DOMPurify.sanitize(updatedHtml);
    this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(sanitizedHtml); // NOSONAR: sanitized by DOMPurify above
  }
}
